module.exports = __webpack_public_path__ + "img/EmotionDiaryIcon.15655e80.svg";